import Model, { attr, hasMany } from '@ember-data/model';
import PledgeModel from './pledge';

export interface NextYearProjectionEndingPledgeInfo {
  pledge_id: string;
  annual_amount: number;
  end_date?: string;
  end_date_reason?: 'overdue' | 'pledge_ended';
}

export interface NextYearProjectionNextYearPledgeInfo {
  pledge_id: string;
  expected_amount: number;
  expected_gifts_count: number;
}

export default class YtdNextYearProjectionModel extends Model {
  @attr('number') goalAmount!: number;
  @attr('date-only') startAt!: Date;
  @attr('date-only') endAt!: Date;
  @attr() pledgeData!: {
    expected: {
      pledge_id: string;
      expected_amount: number;
      expected_gifts_count: number;
    }[];
    overdue: { pledge_id: string }[];
  };
  @attr() newPledgeData!: {
    ended_last_year: NextYearProjectionEndingPledgeInfo[];
    ending_this_year: NextYearProjectionEndingPledgeInfo[];
    next_year: NextYearProjectionNextYearPledgeInfo[];
    last_year_end_date: string;
    this_year_end_date: string;
  };
  @hasMany('pledges', { async: false, inverse: null }) pledges!: PledgeModel[];
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'ytd-next-year-projection': YtdNextYearProjectionModel;
  }
}
